import { gridStringOrNumberComparator } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';

import { Edit02Icon } from '@/components/icons/Edit02Icon';
import { Badge, BadgeVariants } from '@/components/notifications/Badge/Badge';
import { IconRenderer } from '@/components/tables/DataTable/renderers/cell/IconRenderer';
import { TextRenderer } from '@/components/tables/DataTable/renderers/cell/TextRenderer';
import { Column } from '@/components/tables/DataTable/types';

import { RowData } from './AdminTeamsPage.types';
import { AdminTeamsPage_TeamFragment } from './graphql/AdminTeams.generated';

export function mapDataToRows(
  teams: AdminTeamsPage_TeamFragment[]
): Omit<RowData, 'icon'>[] {
  return teams.map((team) => ({
    id: team.id ?? '',
    name: team.name ?? '',
    assignedHouseholdsCount: team.assignedHouseholds?.totalCount ?? 0,
    employeesCount: team.employees?.totalCount ?? 0,
    scimManaged: Boolean(team.workosDirectoryGroupID),
  }));
}

export const useTeamTableColumns = () => {
  return useMemo(() => {
    const columns: Column<RowData>[] = [
      {
        field: 'name',
        headerName: 'Name',
        flex: 1,
        renderCell: TextRenderer({
          textAccompaniment: ({ row }) => {
            if (row.scimManaged) {
              return (
                <Badge variant={BadgeVariants.SecondaryFilled} display="SCIM" />
              );
            }
            return null;
          },
        }),
        sortComparator: (v1: string, v2: string, p1, p2) => {
          return gridStringOrNumberComparator(v1, v2, p1, p2);
        },
      },
      {
        field: 'assignedHouseholdsCount',
        headerName: 'Assigned clients',
        flex: 1,
        renderCell: TextRenderer(),
      },
      {
        field: 'employeesCount',
        headerName: 'Members',
        flex: 1,
        renderCell: TextRenderer(),
      },
      {
        field: 'icon',
        align: 'center',
        renderCell: IconRenderer({
          icon: Edit02Icon,
        }),
        sortable: false,
        width: 64,
        minWidth: 64,
        maxWidth: 64,
      },
    ];

    return columns;
  }, []);
};
